export const environment = {
  production: false,
  baseUrl:
    process.env.REACT_APP_BASE_URL ??
    'https://w05zlebnll.execute-api.us-east-1.amazonaws.com',
  cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN ?? 'localhost',
  fileStoreUrl: process.env.REACT_APP_FILE_STORE_URL,
  googleClientId:
    process.env.GOOGLE_CLIENT_ID ??
    '867275256480-ovk6gl8mhqhfobfo4asmdlc9d04h90iu.apps.googleusercontent.com',
};
